import { useState, type FC } from 'react';
import { Group, Image, type MantineSize, Text } from '@mantine/core';
import { IconBuildingBank } from '@tabler/icons-react';
import { useUnit } from 'effector-react';
import { $banksMap } from '../../model';

interface BankIdentityProps {
    bankCode?: string;
    size?: MantineSize;
}

export const BankIdentity: FC<BankIdentityProps> = ({ bankCode, size = 'sm' }) => {
    const banksMap = useUnit($banksMap);
    const [hasLogoError, setHasLogoError] = useState(false);
    const bank = bankCode ? banksMap.get(bankCode) : undefined;

    if (!bankCode) {
        return null;
    }

    const logoUrl = bank?.logo_url;
    const label = bank?.name_ru ?? bankCode;

    return (
        <Group
            gap={4}
            wrap='nowrap'
        >
            {logoUrl && !hasLogoError ? (
                <Image
                    src={logoUrl}
                    bdrs='md'
                    alt=''
                    decoding='async'
                    fit='contain'
                    loading='lazy'
                    referrerPolicy='no-referrer'
                    w={20}
                    h={20}
                    onError={() => setHasLogoError(true)}
                />
            ) : (
                <IconBuildingBank
                    size={20}
                    stroke={1.5}
                    color='var(--mantine-color-dimmed)'
                    aria-hidden
                />
            )}

            <Text
                component='span'
                size={size}
            >
                {label}
            </Text>
        </Group>
    );
};
